<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
  >
    <section
      v-if="data"
      :class="{
        'pb-40 text-www-color-neutral-medium-dark': true,
      }"
    >
      <ReferAFriend
        v-if="data"
        :data="data"
      />
      <!-- disclaimer -->
      <PortableText
        v-if="data?.disclaimer?.standardPortableText"
        :portable-data="data.disclaimer.standardPortableText"
        :class="{ 'disclaimer-text': true }"
      />
    </section>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { queryReferAFriend } from '~/queries/pages/PageReferAFriend.query';
import type { QueryReferAFriendResult } from '~/sanity/types';
import ReferAFriend from '~/features/ReferAFriend/components/ReferAFriend.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryReferAFriendResult>(queryReferAFriend, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset ||
    data.value?.cardImage?.asset ||
    data.value?.genericCardImage?.asset,
  title: resolvePageTitle(data.value?.htmlTitle ? data.value?.htmlTitle : data.value?.title),
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
});
</script>
<style lang="scss">
.disclaimer-text p.content {
  font-size: 10pt !important;
  font-weight: 400 !important;
  line-height: 24px !important;
}
</style>
